// removed by extract-text-webpack-plugin
module.exports = {"Address":"Addresses__Address__7go7P","Addresses":"Addresses__Addresses__1uESe","button":"Addresses__button__3qT_h"};


//////////////////
// WEBPACK FOOTER
// ./src/components/profile/addresses/Addresses.css
// module id = 6059
// module chunks = 0